import React, { useState } from "react";
import "./AddReference.css";
import { useNavigate } from "react-router-dom";
import { FaPhoneAlt } from "react-icons/fa";
import axios from "axios";
import { Api } from "../../../Admin/BackendApi/api";

const AddReference = () => {

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    address: "",
    mobile: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        navigate("/user/login");
        return;
      }

      const response = await axios.post(
        Api.addReference,
        {
          CustMobile: formData.mobile,
          CustName: formData.name,
          CustAddress: formData.address,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.status === 1) {
        alert("Reference Added Successfully ✅");
        navigate("/user/dashboard/references");
      } else {
        alert(response.data.message);
      }

      console.log(response.data);

      setFormData({
        name: "",
        address: "",
        mobile: "",
      });

    } catch (error) {
      console.error(error);
      alert("Something went wrong ❌");
    }
  };

  const handleViewReference = () => {
    navigate("/user/dashboard/references");
  };

  return (
    <div className="user-add-reference-outer">
      <div className="user-add-reference-container">

        <div className="mobile-input-wrapper" style={{ display: "flex" }}>
          <input
            type="tel"
            name="mobile"
            placeholder="Enter Mobile Number"
            value={formData.mobile}
            onChange={handleChange}
          />
          <FaPhoneAlt
            className="data-icon phone-icon"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              window.location.href = formData.mobile
                ? `tel:${formData.mobile}`
                : "tel:";
            }}
            style={{ cursor: "pointer" }}
          />
        </div>

        <input
          type="text"
          name="name"
          placeholder="Enter Name"
          value={formData.name}
          onChange={handleChange}
        />

        <input
          type="text"
          name="address"
          placeholder="Enter Address"
          value={formData.address}
          onChange={handleChange}
        />

        <div className="user-reference-btn">
          <button onClick={handleSubmit}>Share</button>
          <button onClick={handleViewReference}>
            References
          </button>
        </div>

      </div>
    </div>
  );
};

export default AddReference;